import React, { useState } from 'react'
import iconMap from 'src/assets/icons/Icons'

function Goback() {
    const { Back } = iconMap
    const [clicked, setClicked] = useState(false);
    const handleGoBack = () => {
        if (clicked) return; // ignore double clicks
        setClicked(true);
        window.history.back();
    };
    return (
        <button
            className="flex justify-center items-center font-bold"
            id="goback"
            onClick={handleGoBack}
            disabled={clicked}
        >
            <Back />
            Go Back
        </button>
    )
}

export default Goback
